import React, {useState, useEffect} from 'react';
import axios from 'axios';
import {useHistory, Route, Redirect} from 'react-router-dom';

function EventPost(){
    
    const [name, setName] = useState('');
    const [venue, setVenue] = useState('');
    const [address1, setAddress1] = useState('');
    const [address2, setAddress2] = useState('');
    const [openingday, setOpeningday] = useState('');
    const [closingday, setClosingday] = useState('');
    const [sameday, setSameday] = useState('');
    const [tickets, setTickets] = useState('');
    const [website, setWebsite] = useState('');
    const [opening_hours, setOpening_hours] = useState('');
    const [latitude, setLatitude] = useState('');
    const [longitude, setLongitude] = useState('');
    const [image, setImage] = useState('');
    const [image_copyright, setImage_copyright] = useState('');
    const [isFreeAdmission, setIsFreeAdmission] = useState('');
    const [isRecommendation, setIsRecommendation] = useState('');
    const [stetus, setStetus] = useState('');

    const history = useHistory();

    
    function handleSubmit(event){
        event.preventDefault();
     
        axios.post('/api/events_upload', {
           name, venue, address1, address2, openingday, closingday, sameday, tickets, website, opening_hours, latitude, longitude, image, image_copyright, isFreeAdmission, isRecommendation, stetus

        })
        .then(response=>{
            console.log(response)
            history.push('/events')
        })
        .catch(error=>{
            console.log(error)
        })
    }

    const stetusList = ['digital', 'cancel', 'postponed'];

    const stetusOptions = stetusList.map(stetus =>{
        return(
            <option key={stetus} value={stetus}>
                {stetus}
            </option>
        )
    })

    const freeAdmissionList =['Yes', 'No']

    const freeAdmissioOptions = freeAdmissionList.map(status =>{
        return(
            <option key={status} value={status}>
                {status}
            </option>
        )
    })

    const recommedationList =['Yes', 'No']

    const recommedationOptions = recommedationList.map(isRecommendation =>{
        return(
            <option key={isRecommendation} value={isRecommendation}>
                {isRecommendation}
            </option>
        )
    })

    const samedayList =['Yes', 'No']

    const samedayOptions = samedayList.map(sameday =>{
        return(
            <option key={sameday} value={sameday}>
                {sameday}
            </option>
        )
    })



    return(
        <div className='event_post'>
            <form method='POST' onSubmit={handleSubmit}>
                <div className='admin_post_flex'>
                <label>Name:</label>
                <input type='text' id='name' name='name' placeholder='name of event' value={name} onChange={e=>setName(e.target.value)}/>
                </div>

                <div className='admin_post_flex'>
                <label>Venue:</label>
                <input type='text' id='venue' name='venue' placeholder='name of venue' value={venue} onChange={e=>setVenue(e.target.value)}/>
                </div>

                <div className='admin_post_flex'>
                <label>Address/Street name and number:</label>
                <input type='text' id='address1' name='address1' placeholder='name of street ' value={address1} onChange={e=>setAddress1(e.target.value)}/>
                </div>

                <div className='admin_post_flex'>
                <label>Address/City name and postal code:</label>
                <input type='text' id='address2' name='address2' placeholder='name of city ' value={address2} onChange={e=>setAddress2(e.target.value)}/>
                </div>

                <div className='admin_post_flex'>
                <label>Opeing Day:</label>
                <input type='date' id='openingday' name='openingday' placeholder='address of museum' value={openingday} onChange={e=>setOpeningday(e.target.value)}/>
                </div>

                <div className='admin_post_flex'>
                <label>Closing Day:</label>
                <input type='date' id='closingday' name='closingday' placeholder='city name of address of museum' value={closingday} onChange={e=>setClosingday(e.target.value)}/>
                </div>

                <div className='admin_post_flex'>
                <label>Is Sameday? :</label>
                <select id='sameday' name='sameday' value={sameday} onChange={e=>setSameday(e.target.value)}>
                <option hidden value=''>
                    Select Stetus
                </option>
                {samedayOptions}
                </select>
                </div>

                <div className='admin_post_flex'>
                <label>Tickets:</label>
                <input type='text' id='tickets' name='tickets' placeholder='tickets price' value={tickets} onChange={e=>setTickets(e.target.value)}/>
                </div>

                <div className='admin_post_flex'>
                <label>Web-Site:</label>
                <input type='text' id='web-site' name='web-site' placeholder='Web-Site' value={website} onChange={e=>setWebsite(e.target.value)}/>
                </div>

                <div className='admin_post_flex'>
                <label>Opeing Hours:</label>
                <input type='text' id='opening_hours' name='opening_hours' placeholder='opening hours' value={opening_hours} onChange={e=>setOpening_hours(e.target.value)}/>
                </div>

                <div className='admin_post_flex'>
                <label>Latitude:</label>
                <input type='text' id='latitude' name='latitude' placeholder='latitudes' value={latitude} onChange={e=>setLatitude(e.target.value)}/>
                </div>

                <div className='admin_post_flex'>
                <label>Longitude:</label>
                <input type='text' id='longitude' name='longitude' placeholder='longitude' value={longitude} onChange={e=>setLongitude(e.target.value)}/>
                </div>

                <div className='admin_post_flex'>
                <label>Image:</label>
                <input type='text' id='image' name='image' placeholder='url of image' value={image} onChange={e=>setImage(e.target.value)}/>
                </div>

                <div className='admin_post_flex'>
                <label>Image Copyright:</label>
                <input type='text' id='image-copyright' name='image-copyright' placeholder='image-copyright' value={image_copyright} onChange={e=>setImage_copyright(e.target.value)}/>
                </div>

                <div className='admin_post_flex'>
                <label>Is Free Admission? :</label>
                <select id='isFreeAdmission' name='isFreeAdmission' value={isFreeAdmission} onChange={e=>setIsFreeAdmission(e.target.value)}>
                <option hidden value=''>
                    Select Stetus
                </option>
                {freeAdmissioOptions}
                </select>
                </div>

                <div className='admin_post_flex'>
                <label>Is Your Recommendation? :</label>
                <select id='isRecommendation' name='isRecommendation' value={isRecommendation} onChange={e=>setIsRecommendation(e.target.value)}>
                <option hidden value=''>
                    Select Stetus
                </option>
                {recommedationOptions}
                </select>
                </div>

               <div className='admin_post_flex'>
                <label>Stetus:</label>
                <select id='stetus' name='stetus' value={stetus} onChange={e=>setStetus(e.target.value)}>
                <option hidden value=''>
                    Select Stetus
                </option>
                {stetusOptions}
                </select>
               </div>
  
                <input type='submit' value='Submit'/>
            </form>
        </div>
    )
}

export default EventPost;